import { Component, Input } from '@angular/core';
import { BookingOptionDoc } from '@fry/booking/lib/booking-items/booking-option';
import { CurrencyCode } from '@fry/payments/lib/currency';

@Component({
    selector: 'eas-booking-item-option-summary',
    templateUrl: './booking-item-option-summary.component.html',
    styleUrls: ['booking-item-option-summary.component.css'],
    standalone: false
})
export class BookingItemOptionSummaryComponent {
  @Input() bookingItemOption: BookingOptionDoc;
  @Input() options = { showCapacityInfo: true };

  constructor() {}

  // get grossVolumeToDate(): number {
  //   return this.bookingItemOption.stats
  //     ? this.bookingItemOption.stats.summary.receivedReal + this.bookingItemOption.stats.summary.receivedPending
  //     : 0;
  // }

  // get balanceToDate(): number {
  //   return this.bookingItemOption.stats
  //     ? this.bookingItemOption.stats.summary.balanceReal + this.bookingItemOption.stats.summary.balancePending
  //     : 0;
  // }

  // get refundsToDate(): number {
  //   return this.bookingItemOption.stats
  //     ? this.bookingItemOption.stats.summary.refundedReal + this.bookingItemOption.stats.summary.refundedPending
  //     : 0;
  // }

  get refundsToDatePercentage(): number {
    const income = this.bookingItemOption.stats?.summary.receivedReal || 0;
    const refunded = this.bookingItemOption.stats?.summary.refundedReal || 0;
    return this.bookingItemOption.stats && income !== 0
      ? Math.round((refunded / income) * 100)
      : 0;
  }

  get bookingCurrency(): string {
    return this.bookingItemOption.summary.price.currency ?? CurrencyCode.GBP;
  }
}
